import { FC } from "react";
import { IconButton, IconButtonProps } from "@mui/material";

const StyledIconButton: FC<IconButtonProps & { bgColor?: string }> = ({
  bgColor,
  ...props
}) => {
  return (
    <IconButton
      {...props}
      sx={
        bgColor
          ? {
              backgroundColor: bgColor,
              "&:hover, &.Mui-focusVisible": { backgroundColor: bgColor },
            }
          : null
      }
    />
  );
};

export default StyledIconButton;
